/* eslint-disable jsx-a11y/alt-text */
import React from "react";

import { Box, Typography, Grid } from "@mui/material";

import Image from "../components/image/Image";
import img1 from "../resources/images/service/1.jpg";
import img2 from "../resources/images/service/2.jpg";

export default function Service(props) {
  const nowMediaQuery = props.nowMediaQuery;

  return (
    <div className="section">
      <section className="contents">
        <Box mt={"150px"}>
          <Typography
            variant="h4"
            className="bold"
            textAlign={"center"}
            letterSpacing={2}
            fontSize={25}
            mb={7}
          >
            “나눔으로 빛나는 세상, 여러분의 손길이 큰 희망이 됩니다”
          </Typography>
          <Grid container justifyContent={"center"} mb={2}>
            <Grid
              size={{ xs: 12, sm: 12, md: 4 }}
              display={"flex"}
              direction={"column"}
              justifyContent={"center"}
              alignItems={"center"}
              item
            >
              <Box
                width={nowMediaQuery !== "mobile" ? "30vw" : "80vw"}
                mb={2}
                mr={2}
              >
                <Image disabledEffect alt={""} src={img1} ratio={"16/9"} />
              </Box>
              <Typography
                variant="h5"
                textAlign={"center"}
                sx={{ m: 1 }}
                fontSize={20}
                className="bold"
                color="black"
              >
                자원봉사
              </Typography>
              <Typography
                variant="subtitle1"
                fontSize={17}
                textAlign={"center"}
                lineHeight={2}
              >
                따뜻한 한 끼가 필요한 이들에게 희망을 전해주세요.
                <br /> 음식준비부터 배식, 정리까지 작은 손길이 큰 힘이 됩니다
              </Typography>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 12, md: 4 }}
              display={"flex"}
              direction={"column"}
              justifyContent={"center"}
              alignItems={"center"}
              item
            >
              <Box width={nowMediaQuery !== "mobile" ? "30vw" : "80vw"} mb={2}>
                <Image disabledEffect alt={""} src={img2} ratio={"16/9"} />
              </Box>
              <Typography
                variant="h5"
                textAlign={"center"}
                sx={{ m: 1 }}
                fontSize={20}
                className="bold"
                color="black"
              >
                재능기부
              </Typography>
              <Typography
                variant="subtitle1"
                fontSize={17}
                textAlign={"center"}
                lineHeight={2}
              >
                어려운 이웃들의 지친 마음을 보듬고, 새로운 기회를 열어 주세요.
                <br />
                여러분의 소중한 재능과 지식이 더 나은 세상을 만듭니다.
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </section>
      <section
        className="contents"
        style={{ justifyContent: "left", marginBottom: "20px" }}
      >
        <Typography variant="h5" color="black" mb={2}>
          <strong className="blue">자원봉사</strong>
        </Typography>
        <Box sx={{ border: "1px solid #D3D3D3", p: 2 }}>
          <Typography variant="subtitle1" fontSize={17} lineHeight={2} mb={1}>
            매주 월, 수, 금 도시락 나눔 활동을 도와주실 자원봉사자를 모집합니다.
            <br />
            소중한 시간과 마음을 나누어 세상을 밝히는 일에 함께해주세요.
          </Typography>
          <a
            target="_blank"
            href="https://cafe.naver.com/f-e/cafes/31387977/menus/17"
            rel="noreferrer"
          >
            <Typography
              variant="h4"
              fontSize={17}
              className="bold"
              fontWeight={400}
              lineHeight={1.4}
              backgroundColor="lightgray"
              textAlign={"center"}
              px={4}
              py={2}
              borderRadius={10}
              mr={10}
              width={"220px"}
            >
              자원봉사 신청하기
            </Typography>
          </a>
        </Box>
      </section>
      <section className="contents" style={{ justifyContent: "left" }}>
        <Typography variant="h5" color="black" mb={2}>
          <strong className="blue">재능기부</strong>
        </Typography>
        <Box sx={{ border: "1px solid #D3D3D3", p: 2 }}>
          <Typography variant="subtitle1" fontSize={17} lineHeight={2} mb={1}>
            주거환경개선, 의료·보건, 미용, 교육 등 다양한 재능기부 봉사단(자)를
            모집합니다.
            <br />
            여러분의 따뜻한 마음과 재능은 지역사회의 큰 기쁨과 희망이 됩니다.
          </Typography>
          <a
            href="https://cafe.naver.com/f-e/cafes/31387977/menus/18"
            target="_blank"
            rel="noreferrer"
          >
            <Typography
              variant="h4"
              fontSize={17}
              className="bold"
              fontWeight={400}
              lineHeight={1.4}
              backgroundColor="lightgray"
              textAlign={"center"}
              px={4}
              py={2}
              borderRadius={10}
              mr={10}
              width={"220px"}
            >
              재능기부 신청하기
            </Typography>
          </a>
        </Box>
      </section>

      <section
        className="contents"
        style={{ justifyContent: "left", marginBottom: "20px" }}
      >
        <Box sx={{ p: 2, backgroundColor: "#F2F2F2" }}>
          <Typography variant="h5" color="black" mb={2}>
            <strong>봉사인증</strong>
          </Typography>
          <Typography variant="subtitle1" fontSize={17} lineHeight={2} mb={1}>
            봉사활동에 참여하신 분들께는 봉사 인증서를 발급해 드립니다
            <br />
            아래의 신청 링크를 통해 양식을 작성해주시면 최대한 빠르게 발행해
            드리겠습니다.
          </Typography>
          <a
            href="https://cafe.naver.com/f-e/cafes/31387977/menus/19"
            target="_blank"
            rel="noreferrer"
          >
            <Typography
              variant="h4"
              fontSize={17}
              className="bold"
              fontWeight={400}
              lineHeight={1.4}
              backgroundColor="lightgray"
              textAlign={"center"}
              px={4}
              py={2}
              borderRadius={10}
              mr={10}
              width={"230px"}
            >
              봉사인증서 신청하기
            </Typography>
          </a>
        </Box>
      </section>
    </div>
  );
}
